/* global $, UUID, PCHUSER, PCHGA, device */
import KenoCardView from "keno/app/views/KenoCard";
import { random } from "lodash";

const SELECTED_CLASS = `card__number--selected`;
const USER_SELECTED_CLASS = `card__number--user-selected`;
const QUICKPICK_SELECTED_CLASS = `card__number--quickpick-selected`;

const SUBMIT_DISABLED_CLASS = `card__controls__btn--disabled`;

import ToastView from "keno/app/views/Toast";
import renderTemplate from "keno/app/modules/templateLoader";
import CoachingLightBox from "keno/app/views/CoachingLightBox";
import coachingMessages from "keno/app/mobile/config/coaching-messages";
import IdleMessageLightbox from "keno/app/mobile/views/IdleMessage";
import KenoCountdownView from "keno/app/views/KenoCountdown";
import ChoicesViewMobile from "keno/app/mobile/views/Choices";
import ButtonView from "keno/app/views/Button";
import OneADay from "keno/app/modules/OneADay";
import NoPasswordGameOverScreen from "keno/app/views/NoPasswordGameOverScreen";
import routes from "app/config/routes";

//Delay for idle message
const IDLE_MESSAGE_SECONDS = 30000;

//how long to idle message for -
const IDLE_MESSAGE_SHOW_FOR = 5000;

const KenoCardViewMobile = function() {};

Object.assign(KenoCardViewMobile.prototype, KenoCardView.prototype, {
	EVENTS: {
		SUBMIT: `submit`,
		GLITCH_SUBMIT: `glitchSubmit`,
		CHOICE_SELECT: `choiceSelect`,
		UPDATE_USER_NUMBERS: `updateUserNumbers`
	},

	init: function(appModel) {
		this.showIntroAnims = true;
		this._onCountdownTick = this.onCountdownTick.bind(this);
		this.selectedNumbers = new Set();
		this.userSelectedNumbers = new Set();
		this.quickPickSelectedNumbers = new Set();

		this.appModel = appModel;
		this.countdownView = new KenoCountdownView();
		this.choicesView = new ChoicesViewMobile();
		this.coaching = new CoachingLightBox(window.KENO_GLOBALS.COACHING_SCREENS);
		this.idleMessage = new IdleMessageLightbox(true);

		this.choicesView.addEvent(
			this.choicesView.EVENTS.CHOICE_SELECT,
			this.onGameChoiceSelect.bind(this)
		);

		this.globalDisplayQueue = appModel.globalDisplayQueue;
	},

	mount: function(ctx) {
		this.rootNode = $(`.cardplay`);
		this.gameTimestampId = parseInt(this.rootNode.attr(`data-gameid`), 10);
		this.cardNumber = parseInt(this.rootNode.attr(`data-cardnum`), 10);
		this.cardNumbers = $("ol.card__numbers");

		this.numToSelect = parseInt(this.rootNode.attr(`data-numbers`), 10);

		if (window.KENO_GLOBALS.IS_LOCKED || window.KENO_GLOBALS.IS_LOCKDOWN) {
			this.disableIntroAnims();
		}

		this.countdownView.mount(this.rootNode);
		this.choicesView.mount(ctx);
		this.cardRootNode = $(`.card__form`);
		this.cardControls = $(`.card__controls`);
		this.controlBar = $(`.control-bar`);
		this.cardRootNode.on(
			`touchend`,
			`.card__number`,
			this.onNumberClicked.bind(this)
		);
		this.cardControls.on(
			`click`,
			`.card__controls__btn--clear`,
			this.onClear.bind(this)
		);
		this.cardControls.on(
			`click`,
			`.card__controls__btn--quick`,
			this.onQuickPick.bind(this)
		);
		this.submitBtn = this.cardControls.find(`.card__controls__btn--submit`);
		this.submitBtn.on(`click`, this.onSubmit.bind(this));
		this.disableSubmit();
		this.controlBarNumbers = $(`.control-bar__your-numbers ul`);
		// this.numToSelect = parseInt(this.rootNode.attr("data-numbers"), 10);
		this.numToSelect = 10;
		// check the countdown timer for if we have enough time left to play a choice game
		if (
			!this.choicesView.hasEnoughTimeToPlay(
				this.countdownView.getRemainingSeconds()
			)
		) {
			this.onChoicesOutOfTime();
		} else {
			this.addTickListener();
		}
		this.numberRange = null;
		this.mountControlBar(this.controlBar);
		if (!window.KENO_GLOBALS.IS_LOCKED) {
			this.idleTimeout = this.setIdleTimeout();
		}

		this.idleMessageShowing = false;
		this.coachingScreensShowing = false;
		this.uniNavShowing = false;

		//close coachingscreens when uni-nav is opened
		$(
			`.uninav__burger, .uninav__multi-nav--tokens, .uninav__multi-nav--level`
		).on(`click touchstart`, () => {
			this.toggleCoachingScreens();
			this.uniNavShowing = !this.uniNavShowing; //toggle uniNavShowing
		});
		if (!(this.choicesView && this.choicesView.isShown())) {
			const firstPlay = new OneADay(UUID, `firstPlay`, 1); // userId, storage key, num of days until trigger

			firstPlay.checkIfFirstPlay().then(val => {
				if (val) {
					$(`.wrapper`).addClass(`firstPlay`);
				}

				// wait for display queue to clear before running animations
				if (this.globalDisplayQueue.isCurrentlyDisplaying()) {
					this.globalDisplayQueue.addEmptiedCallback(
						this.startAnims.bind(this)
					);
				} else {
					this.startAnims();
				}
			});
		}

		this.rootNode.on(`touchstart`, () => {
			this.clearIdleTimeout();
		});

		this.controlBar.on(`touchstart`, () => {
			this.clearIdleTimeout();
		});

		//set utag_data for promotional banner since ad is suppressed
		if (document.getElementsByClassName(`top-banner-showing`).length > 0) {
			window.utag_data.promotionalBanner = true;
		}

		if (window.KENO_GLOBALS.IS_LOCKED || window.KENO_GLOBALS.IS_LOCKDOWN) {
			window.setTimeout(() => {
				window.location = routes.HOME;
			}, 10000);
			$("body").addClass("lockdown-overlay");
		}

		//paytable init
		this.initPaytableModal();
	},

	setIdleTimeout: function() {
		if (window.KENO_GLOBALS.IS_LOCKED || window.KENO_GLOBALS.IS_LOCKDOWN)
			return;

		return window.setTimeout(() => {
			if (!this.uniNavShowing) {
				//hide idle message when uni-nav is showing so it doesn't overlap or cause coaching screen issues
				this.showIdleMessage();
			}
		}, IDLE_MESSAGE_SECONDS);
	},
	/* clear idletimeout and hide idle message, reset idle timer */
	clearIdleTimeout: function() {
		this.idleMessage.hideLightbox();
		this.idleMessageShowing = false;
		this.coaching.showLightbox();
		clearTimeout(this.idleTimeout);
		this.idleTimeout = this.setIdleTimeout();
	},
	toggleCoachingScreens: function() {
		if (!this.idleMessageShowing) {
			this.coaching.toggleCoachingScreens();
		}
	},
	mountControlBar: function(controlBar) {
		$(`body`).append(controlBar);
		$(`#page`)
			.find(this.controlBar)
			.remove();
		controlBar.css(`visibility`, `visible`);
	},
	unmountControlBar: function(controlBar) {
		if (controlBar) {
			controlBar.remove();
		}
	},
	unmount: function(ctx) {
		if (this.cardRootNode) {
			this.cardRootNode.off(`click`);
		}
		if (this.submitBtn) {
			this.submitBtn.off(`click`);
		}
		if (this.gos) {
			this.gos.close();
		}

		this.cardRootNode = null;
		this.submitBtn = null;
		//  this.selectedNumbers.clear();
		this.numberRange = null;

		//  this.tabView.unmount(ctx);
		this.removeTickListener();
		this.countdownView.unmount();
		//  this.introView.unmount(ctx);
		this.choicesView.unmount(ctx);
		//  this.glitchView.unmount(ctx);
		clearTimeout(this.idleTimeout);
		this.unmountControlBar(this.controlBar);
		this.idleMessageShowing = false;
		this.coaching.hideLightbox();
		//  coaching.hide();
	},

	handleCoachingScreensOnNumberClicked: function() {},
	onNumberClicked: function(ev) {
		if (this.isQuickPickRunning) {
			return;
		}
		this.handleNumberClicked(ev);
		if (this.selectedNumbers.size >= this.numToSelect) {
			this.coaching.show(
				coachingMessages.submit.msg,
				coachingMessages.submit.top,
				coachingMessages.submit.left,
				coachingMessages.submit.class,
				`body`
			);
		} else {
			this.coaching.show(
				coachingMessages.default.msg,
				coachingMessages.default.top,
				coachingMessages.default.left,
				coachingMessages.default.class,
				`body`
			);
		}
	},

	updateUserNumbers: function() {
		this.fireEvent(this.EVENTS.UPDATE_USER_NUMBERS);
	},
	updateUserNumbersHTML: function(games) {
		this.tabView.updateUserNumbersHTML(games);
	},

	startAnims: function() {
		const that = this;
		const circle = document.querySelector(`.circle`);
		const wrapper = document.querySelector(`.wrapper`);

		const handleAnimationEnd = function(event) {
			if (event.animationName === `zoomOut`) {
				wrapper.classList.add(`done`);
				circle.removeEventListener(
					`webkitAnimationEnd`,
					handleAnimationEnd,
					false
				);
				// Coaching screens
				if (that.cardNumber === 1 && !that.isShownChoices()) {
					that.coaching.show(
						coachingMessages.default.msg,
						coachingMessages.default.top,
						coachingMessages.default.left,
						coachingMessages.default.class,
						`body`
					);
				}
			}
		};

		if (this.showIntroAnims) {
			wrapper.classList.add(`animate`);

			circle.addEventListener(`webkitAnimationEnd`, handleAnimationEnd, false);
		} else {
			wrapper.classList.add(`done`);
		}
	},

	onSubmit: function(ev) {
		if (this.isSubmitDisabled) {
			return;
		}
		ev.preventDefault();
		if (this.hasSelectedAllNumbers()) {
			if (PCHUSER.type === 1 && !PCHUSER.isSocialReg && !PCHUSER.isMiniReg) {
				this.showNoPasswordGOS();
			} else {
				this.fireEvent(this.EVENTS.SUBMIT, [
					this.gameTimestampId,
					this.cardNumber,
					Array.from(this.selectedNumbers.values())
				]);
                if(PCHEvents) PCHEvents.cmd.push(() => { PCHEvents.triggerEvent('keno_play'); });

				//this.showSweepstakesEntryConfirmed();
				//this.showSubmitEntryConfirmed();
			}
		}
	},

	showNoPasswordGOS() {
		this.gos = new NoPasswordGameOverScreen({
			totalTokens: window.totalNoPasswordUserTokens,
			submitNumbersMessage: true,
			rootNode: document.querySelector(`.cardplay`),
			cardData: {
				cardNum: this.appModel.completedCardNumber,
				cardStyle: (this.appModel.completedCardNumber + 9).toString(36)
			}
		});

		$(`.coachingLightBox`).hide();
		$(`.gos__forfeit`).html(`No Thanks, Forfeit My Numbers`);
		this.gos.addEvent(
			this.gos.EVENTS.CREATE_PASS,
			this.onNoPasswordSuccessCallBack.bind(this)
		);
		this.gos.addEvent(
			this.gos.EVENTS.CONTINUE,
			this.onNoPasswordForfeit.bind(this)
		);
		this.gos.open();
	},

	onNoPasswordForfeit() {
		this.fireSubmitEvent();
	},
	onNoPasswordSuccessCallBack() {
		this.appModel._data.currentUser.isFullyRegistered = true;
		this.refreshOnSubmit = true;
		this.fireSubmitEvent();
	},
	fireSubmitEvent() {
		if (!this.isSubmitDisabled && this.hasSelectedAllNumbers(true)) {
			this.fireEvent(this.EVENTS.SUBMIT, [
				this.gameTimestampId,
				this.cardNumber,
				Array.from(this.selectedNumbers.values())
			]);
		}
	},

	disableSubmit: function() {
		this.isSubmitDisabled = true;
		ButtonView.disableForSubmitPending(this.submitBtn);
		if (this.choicesView.isShown()) {
			this.choicesView.disableSubmit();
		}
	},

	enableSubmit: function() {
		this.isSubmitDisabled = false;
		ButtonView.enableFromSubmitPending(this.submitBtn);
		if (this.choicesView.isShown()) {
			this.choicesView.enableSubmit();
		}
	},

	disableSubmitBtn: function() {
		this.submitBtn.addClass(SUBMIT_DISABLED_CLASS);
	},

	enableSubmitBtn: function() {
		this.isSubmitDisabled = false;

		this.submitBtn.removeClass(SUBMIT_DISABLED_CLASS);
	},

	getNumberRange: function() {
		if (this.numberRange === null) {
			this.numberRange = [
				parseInt(
					this.cardRootNode
						.find(`.card__number:first-child`)
						.attr(`data-number`),
					10
				),
				parseInt(
					this.cardRootNode
						.find(`.card__number:last-child`)
						.attr(`data-number`),
					10
				)
			];
		}
		return this.numberRange;
	},

	getCardNumber: function() {
		return this.cardNumber;
	},

	getGameTimestampId: function() {
		return this.gameTimestampId;
	},

	hasSelectedAllNumbers: function() {
		return this.selectedNumbers.size >= this.numToSelect;
	},

	addTickListener: function() {
		this.countdownView.addEvent(
			this.countdownView.EVENTS.TICK,
			this._onCountdownTick
		);
	},

	removeTickListener: function() {
		this.countdownView.removeEvent(
			this.countdownView.EVENTS.TICK,
			this._onCountdownTick
		);
	},
	showIdleMessage: function() {
		this.idleMessage.show(
			coachingMessages.idleMessage.msg,
			coachingMessages.idleMessage.top,
			coachingMessages.idleMessage.left,
			coachingMessages.idleMessage.class,
			`.maincontent`
		);
		this.idleMessageShowing = true;

		this.coaching.hideLightbox();

		this.idleMessageShowTimeout = window.setTimeout(() => {
			this.clearIdleTimeout();
		}, IDLE_MESSAGE_SHOW_FOR);
	},

	onChoicesOutOfTime: function() {
		if (this.choicesView && this.choicesView.isShown()) {
			this.choicesView.showOutOfTimeOverlay();
		}
	},

	onGlitchSubmit: function() {
		if (!this.isSubmitDisabled) {
			this.fireEvent(this.EVENTS.GLITCH_SUBMIT);
		}
	},

	onGameChoiceSelect: function(choiceId) {
		if (!this.isSubmitDisabled) {
			this.fireEvent(this.EVENTS.CHOICE_SELECT, [choiceId]);
		}
	},

	onClear: function(ev) {
		if (ev) {
			ev.preventDefault();
		}

		if (this.isQuickPickRunning) {
			return;
		}

		this.cardRootNode
			.find(`.` + SELECTED_CLASS)
			.removeClass(SELECTED_CLASS)
			.removeClass(USER_SELECTED_CLASS)
			.removeClass(QUICKPICK_SELECTED_CLASS);
		this.selectedNumbers.clear();
		this.userSelectedNumbers.clear();
		this.quickPickSelectedNumbers.clear();
		this.removeAllNumbersFromControlBar();
		this.disableSubmitBtn();
		this.coaching.show(
			coachingMessages.default.msg,
			coachingMessages.default.top,
			coachingMessages.default.left,
			coachingMessages.default.class,
			`body`
		);
	}, //placeholder for now until GA tags story, might be able to reuse function in desktop view

	handleNumberClicked: function(ev) {
		let $targ = $(ev.target);

		$targ = $targ.hasClass(`.card__number`)
			? $targ
			: $targ.parents(`.card__number`);
		if ($targ.length === 0) {
			return;
		}
		const num = parseInt($targ.attr(`data-number`), 10);

		// deselect the number
		if (this.selectedNumbers.has(num)) {
			this.selectedNumbers.delete(num);
			this.userSelectedNumbers.delete(num);
			this.quickPickSelectedNumbers.delete(num);
			this.removePickedNumberFromControlBar(num);
			$targ
				.removeClass(SELECTED_CLASS)
				.removeClass(USER_SELECTED_CLASS)
				.removeClass(QUICKPICK_SELECTED_CLASS);
			this.disableSubmitBtn();
		} else if (!this.hasSelectedAllNumbers()) {
			// select tje number
			this.selectedNumbers.add(num);
			this.userSelectedNumbers.add(num);
			this.addPickedNumberToControlBar(num);
			$targ.addClass(SELECTED_CLASS + " " + USER_SELECTED_CLASS);
			if (this.hasSelectedAllNumbers()) {
				this.enableSubmitBtn();
			}
		}
	},
	addPickedNumberToControlBar: function(num) {
		this.controlBarNumbers.append(`<li>` + num + `</li>`);
	},
	removePickedNumberFromControlBar: function(num) {
		const numbers = this.controlBarNumbers.find(`li`);

		numbers.forEach(number => {
			if (parseInt(number.innerHTML, 10) === num) {
				number.remove();
			}
		});
	},
	removeAllNumbersFromControlBar: function() {
		this.controlBarNumbers.html(``);
	},
	showCreatePasswordLightbox: function() {},

	isShownChoices: function() {
		const rootNode = $(`.choices__games`);

		return !!rootNode && rootNode.length > 0;
	},
	showPromotionEntryConfirmed: function(imgPath, textContent) {
		let onClose = null,
			view = null;

		const promise = new Promise(resolve => {
			view = new ToastView(`shared/promotion-entry-confirmed.html`, {
				imgPath: imgPath,
				textContent: textContent
			});
			onClose = () => {
				view.removeEvent(view.EVENTS.CLOSED, onClose);
				resolve();
			};

			view.addEvent(view.EVENTS.CLOSED, onClose);
			view.show();
		});

		return promise;
	},
	showEntryConfirmedCircle: function(imgPath) {
		const promise = new Promise(resolve => {
			const entryConfirmedCircle = $(
				renderTemplate(`shared/mobile-promotion-circle-entry.html`, {
					imgPath: imgPath
				})
			);

			$(`body`)
				.addClass(`noScroll`)
				.append(entryConfirmedCircle[0]);
			document.querySelector(`.wrapperEntry`).classList.add(`display`);
			setTimeout(() => {
				document.querySelector(`.wrapperEntry`).classList.remove(`display`);
				$(`body`).removeClass(`noScroll`);
				resolve();
			}, 3000);
		});

		return promise;
	},
	disableIntroAnims: function() {
		this.showIntroAnims = false;
	},

	/**
	 * set open (link) and close ('X' and click behind) events for paytable modal
	 */
	initPaytableModal: function() {
		this.paytableLink = $(".cardplay__paytable");
		this.paytableLink.on("click", function() {
			$(".paytable-modal").removeClass("paytable-modal__hide");
		});

		this.paytableClose = $(".paytable__closebutton");
		this.paytableClose.on("click", function() {
			$(".paytable-modal").addClass("paytable-modal__hide");
		});
	}
});

export default KenoCardViewMobile;
